import React from "react";
import { format } from "date-fns";
import { localeMap } from "components/DatePickers/locales.interfaces";
import { LocaleKey } from "components/DatePickers/locales.interfaces";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useConfig } from "@thekilroygroup/shared-ui";

export const HeadRow = () => {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("sm"));
  const { locale } = useConfig();
  return (
    <tr>
      {Array.from({ length: 7 }, (_, index) => {
        const dayName = format(
          new Date(2024, 0, index + 1),
          isMobile ? "EEE" : "EEEE",
          {
            locale: localeMap[locale as LocaleKey],
          },
        );

        return (
          <Box
            component="td"
            key={index}
            sx={{
              p: 1,
              textAlign: "center",
            }}
          >
            <Typography variant="titleExtraSmall">{dayName}</Typography>
          </Box>
        );
      })}
    </tr>
  );
};
